import { useQuery } from "@tanstack/react-query";
import { accessioningPanelsService } from "../services/accessioningPanels.service";

export function useAccessioningPanelOptions() {
  return useQuery({
    queryKey: ["accessioning", "panel-options"],
    queryFn: accessioningPanelsService.listOptions,
    staleTime: 60_000,
  });
}
